<template>
  <div>
    <div class="es-op-box">
      <el-input placeholder="请输入关键字"
                v-model="queryObj.keyWord"
                size="small"
                class="query"
                style="float: left"
                clearable
                @change="()=>{this.queryObj.pageNum = 1;loadCultiManageList()}">
        <i slot="suffix"
           class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-select style="float: left"
                       class="query"
                       size="small"
                       v-model="queryObj.cultivatetype"
                       placeholder="请选择培训类型"
                       clearable
                       filterable
                       @clear="
                () => {
                  delete this.queryObj.certitype;
                }
              "
                       @change="
                () => {
                  this.queryObj.pageNum = 1;
                  loadCultiManageList();
                }
              ">
              <el-option v-for="item in cultiType"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>


      <el-button type="primary"
                 icon="el-icon-font el-icon-web__tianjia"
                 size="mini"
                 style="margin-right:6px"
                 @click="add_init">新增</el-button>
      <es-delete @del="del()"
                 type="button"></es-delete>
    </div>
    <el-table :data="pageData.list"
              ref="cultiTable"
              border
              stripe
              size="mini"
              height="calc(100vh - 180px)"
              v-loading="loading">
      <el-table-column type="selection"
                       width="40"
                       align="center">
      </el-table-column>
      <el-table-column type="index"
                       label="序号"
                       width="50"
                       align="center">
      </el-table-column>
      <el-table-column prop="userName"
                       label="人员名称">
      </el-table-column>
      <el-table-column prop="cultivatetypeName"
                       label="培训类型">
      </el-table-column>
      <el-table-column prop="traiproj"
                       label="培训项目名称">
      </el-table-column>
      <el-table-column prop="traiinst"
                       label="培训机构名称">
      </el-table-column>
      <el-table-column prop="results"
                       label="所获成绩">
      </el-table-column>
      <el-table-column prop="startdate"
                       label="培训起始日期">
      </el-table-column>
      <el-table-column prop="enddate"
                       label="培训结束日期">
      </el-table-column>
      <el-table-column label="操作"
                       width="80"
                       align="center">
        <template slot-scope="scope">
          <el-link :underline="false"
                   title="编辑"
                   @click="edit_init(scope.row)"
                   type="primary"><i class="el-icon-font el-icon-bianji"></i></el-link>
          <el-divider direction="vertical"></el-divider>
          <es-delete @del="del(scope.row.id)"
                     :key="scope.row.id"
                     type="icon"></es-delete>
        </template>
      </el-table-column>
    </el-table>
    <div class="es-page-box">
      <es-pagination :data="pageData"
                     @change="(cpage)=>{this.queryObj.pageNum=cpage;this.loadCultiManageList()}">
      </es-pagination>
    </div>
    <!--编辑人员证书-->
    <el-dialog :visible.sync="editVisible"
               @closed="()=>this.$refs['cultiForm'].clearValidate()"
               width="500px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>编辑人员证书
      </span>
      <el-form :model="cultiInfo"
               :rules="rules"
               size="mini"
               label-position="right"
               label-width="150px"
               ref="cultiForm">
        <el-form-item prop="cultivatetype"
                label="培训类型">
            <el-select ref="cultivatetypeSelect"
                       style="width: 200px"
                       v-model="cultiInfo.cultivatetype"
                       placeholder="请选择培训类型"
                       clearable
                       filterable>
              <el-option v-for="item in cultiType"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        <el-form-item prop="traiproj"
                      label="培训名称">
          <el-input v-model="cultiInfo.traiproj"
                    placeholder="请输入培训项目名称"
                    style="width:200px"
                    clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="traiinst"
                      label="培训机构">
          <el-input v-model="cultiInfo.traiinst"
                    placeholder="请输入培训机构"
                    style="width:200px"
                    clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="results"
                      label="培训结果">
          <el-input v-model="cultiInfo.results"
                    placeholder="请输入培训结果"
                    style="width:200px"
                    clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="startdate"
                      label="开始日期">
          <el-date-picker v-model="cultiInfo.startdate"
                            type="date"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            style="width: 200px"
                            placeholder="选择开始日期">
            </el-date-picker>
        </el-form-item>
        <el-form-item prop="enddate"
                      label="结束日期">
            <el-date-picker v-model="cultiInfo.enddate"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  style="width: 200px"
                  placeholder="选择结束日期">
            </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini"
                   @click="editVisible = false">取 消</el-button>
        <el-button type="primary"
                   size="mini"
                   @click="submitCulti()"
                   :loading="saving">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'cultimanage',
  props: ["funcs","paramId"],
  data () {
    return {
      queryObj: { pageNum: 1, pageSize: 20 },//查询条件
      userInfo:{},
      pageData: {},
      cultiType:[],
      editVisible: false,
      cultiInfo: {},//系统信息
      rules: {//验证条件
        traiproj: [
          { required: true, message: '请输入培训项目名称', trigger: 'blur' },
          { max: 20, message: '不能超过20个字符', trigger: 'blur' }
        ],
        cultivatetype: [
          { required: true, message: '请选择培训类型', trigger: 'blur' }
        ],
        results: [
          { required: true, message: '请输入培训结果', trigger: 'blur' }
        ],
        startdate: [
          { required: true, message: '请选择开始日期', trigger: 'blur' }
        ],
        enddate: [
          { required: true, message: '请选择结束日期', trigger: 'blur' }
        ]
      },
      loading: false,
      saving: false,
      fileList: [],
      fileListView: [],
    }
  },
  methods: {
    //页面初始化
    init () {
      this.userInfo = this.paramId
      this.$set(this.queryObj, "emplid", this.paramId.userId);
      this.loadCultiManageList()
      this.loadCultiTypeList();
    },
    //从后台查询系统专业列表
    loadCultiManageList () {
      this.loading = true
      let _this = this
      this.$ajax.get('/base/userCulti/list', this.queryObj).then(msg => {
        msg.list.forEach(function(item) {
          item.userName = _this.userInfo.userName
        });
        this.pageData = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })

    },
    //初始化证书类型下拉框
    loadCultiTypeList () {
      this.$ajax
        .get("/base/culti/list_all")
        .then((msg) => {
          this.cultiType = msg;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    add_init () {
      this.editVisible = true
      this.cultiInfo = {}
    },
    edit_init (row) {
      this.editVisible = true
      this.cultiInfo = JSON.parse(JSON.stringify(row))
    },
    submitCulti () {
      this.$refs["cultiForm"].validate(valid => {
        if (valid) {
          let url = "/base/userCulti/add";
          if (this.cultiInfo.id != null) {
            url = "/base/userCulti/edit";
          }
          this.cultiInfo.emplid = this.userInfo.userId
          this.saving = true
          this.$ajax.post(url, this.cultiInfo).then(msg => {
            this.saving = false
            this.loadCultiManageList()
            this.editVisible = false
            this.$message.success(msg)
          }).catch(err => {
            this.$message.error(err)
            this.saving = false
          })
        }
      })
    },
    del (delId) {
      let ids = []
      if (delId != null) {
        ids = [delId]
      } else {
        this.$refs["cultiForm"].selection.forEach((ele) => {
          ids.push(ele.id)
        })
      }
      if (ids.length > 0) {
        this.loading = true
        this.$ajax.post('/base/userCulti/delete', { 'ids': ids }).then(msg => {
          this.loading = false
          this.$message.success(msg)
          this.queryObj.pageNum = 1//删除之后，回到第一页
          this.loadCultiManageList()
        }).catch(err => {
          this.$message.error(err)
          this.loading = false
        })
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped>
</style>
